import React from 'react';
import { AdaptiveForm } from '@cochlear-design-system/features.adaptiveForms';
import { Col } from '@cochlear-design-system/foundation';

export const LeftPanel = ({ config, data, labels }) => {
  return (
    <Col xs={4}>
      <AdaptiveForm labels={labels} config={config} data={data} />
    </Col>
  );
};
